/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingSusyRon/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OnboardingSusyRon({
  children,
  viewPath = "/DesignSystem/Images/OnboardingSusyRon",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 558,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 700
  
}) {
  return (<React.Fragment
>
<img
  data-testid="OnboardingSusyRon.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-Z1bjbmG': alignSelf,'--bc-2-Z1bjbmG': backgroundColor,'--bblr-3-Z1bjbmG': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-Z1bjbmG': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-Z1bjbmG': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-Z1bjbmG': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-Z1bjbmG': typeof height === 'number' ? `${height}px` : height,'--mb-8-Z1bjbmG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-Z1bjbmG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-Z1bjbmG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-Z1bjbmG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-Z1bjbmG': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}